import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user_id: null,
  survey_id: null,
  activeMenu: "setup",
};

const feedbackSlice = createSlice({
  name: "feedbackSlice",
  initialState,
  reducers: {
    setActiveMenu: (state, action) => {
      state.activeMenu = action.payload;
    },
    setFeedbackSurveyId: (state, action) => {
      state.survey_id = action.payload;
    },
    setUserId: (state, action) => {
      state.user_id = action.payload;
    },
  },
});

export const { setActiveMenu, setFeedbackSurveyId, setUserId } =
  feedbackSlice.actions;
export default feedbackSlice.reducer;
